// 1. 导入
import { defineStore } from 'pinia'
// 引入子模块的常量
import { LOCAL_LANG_KEY_PINGTAI } from '@/common/src/constants/system-constant.ts'
// 字典
const currentValMap = {
  'zh-HK': 'val',
  // 'zh-HK': 'tcVal',
  'en-US': 'enVal',
}
const currentLabelMap = {
  'zh-HK': 'title',
  // 'zh-HK': 'tcTitle',
  'en-US': 'enTitle',
}
const currentNameMap = {
  'zh-HK': 'name',
  // 'zh-HK': 'tcName',
  'en-US': 'enName',
}
const currentAcupointNameMap = {
  'zh-HK': 'acupointName',
  // 'zh-HK': 'acupointTcName',
  'en-US': 'acupointEnName',
}
// 藥品
const currentMedicantNameMap = {
  'zh-HK': 'medicantName',
  // 'zh-HK': 'medicantTcName',
  'en-US': 'medicantEnName',
}
// 规格
const currentMedicantSkuNameMap = {
  'zh-HK': 'medicantSkuName',
  // 'zh-HK': 'medicantSkuTcName',
  'en-US': 'medicantSkuEnName',
}
// 經脈
const currentMeridianNameMap = {
  'zh-HK': 'meridianName',
  // 'zh-HK': 'meridianTcName',
  'en-US': 'meridianEnName',
}
// 使用單位
const currentUseUnitMap = {
  'zh-HK': 'useUnit',
  // 'zh-HK': 'useUnit',
  'en-US': 'useEnUnit',
}
interface InState {
  userInfo: Record<string, any> | undefined
  account: string | undefined // 賬號
  passwordNeedEdit: boolean // 密码是否需要更改
  arrList: Record<string, any>[]
  currentLang: string
  currentVal: string
  currentLabel: string
  currentName: string
  currentMeridianName: string
  currentAcupointName: string
  currentMedicantName: string
  currentMedicantSkuName: string
  currentUseUnit: string
}
// 2. 使用
const useLogin = defineStore('login', {
  state: (): InState => {
    return {
      userInfo: undefined, // 用户名称等信息
      account: undefined, // 賬號
      passwordNeedEdit: false, // 密码是否需要更改
      arrList: [],
      currentLang: localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || '',
      currentVal:
        currentValMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'val', // 國際化中可能初始化時獲取不到的
      currentLabel:
        currentLabelMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'title', // 國際化中可能初始化時獲取不到的
      currentName:
        currentNameMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'name', // 國際化中可能初始化時獲取不到的
      currentMeridianName:
        currentMeridianNameMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'meridianName', // 國際化中可能初始化時獲取不到的
      currentAcupointName:
        currentAcupointNameMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'acupointName', // 國際化中可能初始化時獲取不到的
      currentMedicantName:
        currentMedicantNameMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'medicantName', // 國際化中可能初始化時獲取不到的
      currentMedicantSkuName:
        currentMedicantSkuNameMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'medicantSkuName', // 國際化中可能初始化時獲取不到的
      currentUseUnit:
        currentUseUnitMap[
          localStorage.getItem(LOCAL_LANG_KEY_PINGTAI) || 'zh-HK'
        ] || 'useUnit', // 國際化中可能初始化時獲取不到的
    }
  },
  actions: {
    // 设置语言
    setCurrentLang(currentLang: string) {
      this.currentLang = currentLang
      localStorage.setItem(LOCAL_LANG_KEY_PINGTAI, currentLang)
      this.currentVal = currentValMap[currentLang || 'zh-HK'] || 'val'
      this.currentLabel = currentLabelMap[currentLang || 'zh-HK'] || 'title'
      this.currentName = currentNameMap[currentLang || 'zh-HK'] || 'name'
      this.currentMeridianName =
        currentMeridianNameMap[currentLang || 'zh-HK'] || 'meridianName'
      this.currentAcupointName =
        currentAcupointNameMap[currentLang || 'zh-HK'] || 'acupointName'
      this.currentMedicantName =
        currentMedicantNameMap[currentLang || 'zh-HK'] || 'medicantName'
      this.currentMedicantSkuName =
        currentMedicantSkuNameMap[currentLang || 'zh-HK'] || 'medicantSkuName'
      this.currentUseUnit =
        currentUseUnitMap[currentLang || 'zh-HK'] || 'useUnit'
    },
    // 存储登錄賬號
    setAccount(str?: string | undefined) {
      this.account = str
    },
    // 密码是否需要更改
    setPasswordNeedEdit(bool: boolean) {
      this.passwordNeedEdit = bool
    },
    // 退出登录
    logout() {
      this.setAccount()
    },
  },
  getters: {
    // 不能跟state同名
    // currentLang: (state) => {
    //   console.log('state ==== ', state)
    //   return state.currentLang
    // }
  },
  // 所有数据持久化
  // persist: {
  //     enabled: true,
  // },

  // 持久化存储插件其他配置
  // persist: {
  //     enabled: true,
  //     strategies: [
  //         // 修改存储中使用的键名称，默认为当前 Store的 id
  //         // 修改为 sessionStorage，默认为 localStorage
  //         // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
  //         { key: 'storekey', storage: sessionStorage, paths: ['routes', 'userInfo'] }, // routes 和 userInfo字段用sessionStorage存储
  //         { key: 'storekey', storage: localStorage, paths: ['accessToken', 'currentLang'] }, // accessToken字段用 localstorage存储
  //     ],
  // },
  // 所有数据持久化
  // persist: true,
  // 持久化存储插件其他配置
  persist: {
    // 修改存储中使用的键名称，默认为当前 Store的 id
    // key: 'store-login',
    // 修改为 sessionStorage，默认为 localStorage
    // storage: window.sessionStorage,
    // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
    // paths: ['account'],
  },
})

// 3. 导出
export default useLogin
